import { render } from "./SalesPerson.vue?vue&type=template&id=ebd7648e"
import script from "./SalesPerson.vue?vue&type=script&lang=js"
export * from "./SalesPerson.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__